const footerLinks = [
  {
    title: "栏目导航",
    links: [
      { label: "下饭神番", href: "#trending" },
      { label: "主题分类", href: "#categories" },
      { label: "新番速递", href: "#new-season" },
      { label: "口碑评价", href: "#reviews" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "常见问题", href: "#faq" },
      { label: "关于我们", href: "#about" },
      { label: "返回顶部", href: "#top" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* brand */}
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-emotion-happy-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl text-foreground-900">小狗看番</span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xs">
              专注搞笑番推荐、沙雕动画与解压爆笑日常合集的下饭神番聚合站，
              无脑乐呵不费脑，每集都能笑出声。
            </p>
          </div>

          {/* links */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base text-foreground-900 mb-4">{col.title}</h3>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 inline-flex items-center gap-1.5 transition-colors"
                    >
                      <i className="ri-arrow-right-s-line text-primary-500"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* slogan */}
          <div className="md:col-span-1">
            <h3 className="font-heading text-base text-foreground-900 mb-4">今日份快乐</h3>
            <div className="rounded-2xl bg-primary-50 p-5">
              <p className="text-sm text-foreground-700 leading-relaxed">
                吃饭没番看？来小狗看番，选一部下饭神番，把今天的不开心都笑掉。
              </p>
              <a
                href="#trending"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 text-sm font-bold transition-colors"
              >
                去挑神番
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 小狗看番 · 专注你的下饭神番
          </p>
          <p className="text-xs text-foreground-500">
            本站仅作番剧推荐整理，观看以各正版平台为准
          </p>
        </div>
      </div>
    </footer>
  );
}